export default "__VITE_ASSET__BS8BCw9K__"